const LoadingAnimation = () => {
  return (
    <div className="fixed font-basefont inset-0 bg-white flex items-center justify-center z-50">
      <div className="text-center">
        {/* Logo-Inspired SVG Spinner Animation */}
        <div className="mb-6">
          <svg
            className="mx-auto h-16 w-16 animate-spin-slow"
            viewBox="0 0 64 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            {/* Outer dotted arc, inspired by your logo */}
            <g stroke="#004080" strokeWidth="2" strokeLinecap="round">
              <circle cx="32" cy="32" r="28" strokeDasharray="4 10" />
              {/* Second arc, inner layer */}
              <circle cx="32" cy="32" r="20" strokeDasharray="3 6" opacity="0.7" />
              {/* A few standalone dots like the logo */}
              <circle cx="48" cy="16" r="2" fill="#004080" />
              <circle cx="16" cy="48" r="2" fill="#004080" />
            </g>
          </svg>
        </div>

        {/* Company Name */}
        <h2 className="text-2xl font-semibold text-[#004080] mb-2">
          PG Overseas Services
        </h2>

        {/* Tagline */}
        <p className="text-gray-600 font-semibold animate-pulse mb-4">
          Your Global Recruitment Partner
        </p>


        <div className="w-64 h-2 bg-gray-200 rounded-full overflow-hidden mx-auto">
          <div className="h-full bg-[#004080] rounded-full animate-loading-bar"></div>
        </div>
      </div>

      <style>{`
        @keyframes loading-bar {
          0% { width: 0%; }
          100% { width: 100%; }
        }
        .animate-loading-bar {
          animation: loading-bar 2.5s ease-in-out infinite;
        }
        @keyframes spin-slow {
          0% { transform: rotate(0deg);}
          100% { transform: rotate(360deg);}
        }
        .animate-spin-slow {
          animation: spin-slow 2s linear infinite;
        }
      `}</style>
    </div>
  );
};

export default LoadingAnimation;


// const LoadingAnimation = () => {
//   return (
//     <div className="fixed font-basefont inset-0 bg-white flex items-center justify-center z-50">
//       <div className="text-center">
//         {/* Enhanced 3D Globe Animation */}
//         <div className="mb-8 relative w-28 h-28 mx-auto">
//           <svg
//             className="w-full h-full"
//             viewBox="0 0 120 120"
//             xmlns="http://www.w3.org/2000/svg"
//             style={{ filter: 'drop-shadow(0 3px 16px #b5b8bb33)' }}
//           >
//             {/* Orbital Bands */}
//             <ellipse
//               cx="60" cy="60" rx="52" ry="24"
//               fill="none"
//               stroke="url(#globeGradient1)"
//               strokeWidth="4"
//               style={{ animation: "orbit1 2.7s linear infinite" }}
//             />
//             <ellipse
//               cx="60" cy="60" rx="44" ry="12"
//               fill="none"
//               stroke="url(#globeGradient2)"
//               strokeWidth="3"
//               style={{ animation: "orbit2 2.2s linear infinite" }}
//               transform="rotate(23 60 60)"
//             />
//             {/* Dots on Orbit - animated using SVG animateTransform for added polish */}
//             <circle r="3.2" fill="#3468ac">
//               <animateTransform
//                 attributeName="transform"
//                 type="rotate"
//                 from="0 60 60"
//                 to="360 60 60"
//                 dur="2.8s"
//                 repeatCount="indefinite"
//               />
//               <animate
//                 attributeName="cx"
//                 values="100;106;100"
//                 dur="2.8s"
//                 repeatCount="indefinite"
//               />
//               <animate
//                 attributeName="cy"
//                 values="60;77;60"
//                 dur="2.8s"
//                 repeatCount="indefinite"
//               />
//             </circle>
//             <circle r="2" fill="#b5b8bb" cx="40" cy="80">
//               <animateTransform
//                 attributeName="transform"
//                 type="rotate"
//                 from="180 60 60"
//                 to="540 60 60"
//                 dur="3.1s"
//                 repeatCount="indefinite"
//               />
//             </circle>
//             {/* Orbiting Rectangle "tiles" */}
//             <rect
//               x="75" y="100" width="8" height="3"
//               fill="#3468ac" rx="1.5"
//               transform="rotate(-13 79 101.5)"
//             >
//               <animateTransform
//                 attributeName="transform"
//                 type="rotate"
//                 from="0 60 60"
//                 to="360 60 60"
//                 dur="2.7s"
//                 repeatCount="indefinite"
//               />
//             </rect>
//             {/* Central Pulse */}
//             <circle cx="60" cy="60" r="8" fill="#3468ac" className="animate-pulse" />
//             {/* Gradients */}
//             <defs>
//               <linearGradient id="globeGradient1" x1="30" y1="60" x2="90" y2="80" gradientUnits="userSpaceOnUse">
//                 <stop stopColor="#3468ac" />
//                 <stop offset="0.55" stopColor="#b5b8bb" />
//                 <stop offset="1" stopColor="#3468ac" />
//               </linearGradient>
//               <linearGradient id="globeGradient2" x1="16" y1="20" x2="105" y2="80" gradientUnits="userSpaceOnUse">
//                 <stop stopColor="#b5b8bb" />
//                 <stop offset="1" stopColor="#3468ac" />
//               </linearGradient>
//             </defs>
//           </svg>
//         </div>

//         {/* Company Name */}
//         <h2 className="text-2xl font-semibold text-[#3468ac] mb-2 tracking-wide">
//           PG Overseas Services
//         </h2>

//         {/* Tagline */}
//         <p className="text-gray-500 animate-pulse mb-7 tracking-widest" style={{fontSize:'1em',letterSpacing:'0.18em'}}>
//           TRUST AND TRUTH
//         </p>

//         {/* Gradient Synchronized Loading Bar */}
//         <div className="w-64 h-2 mx-auto bg-gray-200 rounded-full overflow-hidden">
//           <div
//             className="h-full rounded-full animate-loading-bar"
//             style={{
//               background: 'linear-gradient(90deg, #3468ac, #b5b8bb 75%, #3468ac)',
//               animationTimingFunction: 'ease-in-out'
//             }}
//           ></div>
//         </div>
//       </div>
//       <style>{`
//         @keyframes loading-bar {
//           0% { width: 0%; }
//           80% { width: 100%; }
//           100% { width: 100%; opacity: 0.4; }
//         }
//         .animate-loading-bar {
//           animation: loading-bar 2.5s cubic-bezier(.53,.21,.29,.85) infinite;
//         }
//         @keyframes orbit1 {
//           0% { transform: rotate(0deg); }
//           100% { transform: rotate(360deg);}
//         }
//         @keyframes orbit2 {
//           0% { transform: rotate(360deg);}
//           100% { transform: rotate(0deg);}
//         }
//       `}</style>
//     </div>
//   );
// };

// export default LoadingAnimation;





// const LoadingAnimation = () => {
//   return (
// <div className="fixed font-basefont inset-0 bg-[#0a2647] flex items-center justify-center z-50">
//       <div className="text-center">
//         {/* SVG Spinner Inspired by Logo */}
//         <div className="mb-6 relative w-20 h-20 mx-auto">
//           <svg
//             className="w-full h-full animate-spin-slow"
//             viewBox="0 0 64 64"
//             xmlns="http://www.w3.org/2000/svg"
//           >
//             <g stroke="#004080" strokeWidth="2" strokeLinecap="round">
//               {/* Outer dotted arc */}
//               <circle cx="32" cy="32" r="28" strokeDasharray="4 10" />
//               {/* Inner dotted arc */}
//               <circle cx="32" cy="32" r="20" strokeDasharray="3 6" opacity="0.7" />
//               {/* Logo-like dots */}
//               <circle cx="48" cy="16" r="2" fill="#004080" />
//               <circle cx="16" cy="48" r="2" fill="#004080" />
//             </g>
//           </svg>

//           {/* Center pulse dot */}
//           <div className="absolute top-1/2 left-1/2 w-4 h-4 bg-[#004080] rounded-full animate-pulse transform -translate-x-1/2 -translate-y-1/2" />
//         </div>

//         {/* Company Name */}
//         <h2 className="text-2xl font-semibold text-[#004080] mb-2">
//           PG Overseas Services
//         </h2>

//         {/* Tagline */}
//         <p className="text-gray-700 animate-pulse mb-4">
//           Your Global Recruitment Partner
//         </p>

//         {/* Animated Loading Bar */}
//         <div className="w-64 h-2 bg-gray-300 rounded-full overflow-hidden mx-auto">
//           <div className="h-full bg-[#004080] rounded-full animate-loading-bar"></div>
//         </div>
//       </div>

//       {/* Animations */}
//       <style>{`
//         @keyframes loading-bar {
//           0% { width: 0%; }
//           100% { width: 100%; }
//         }

//         .animate-loading-bar {
//           animation: loading-bar 2.5s ease-in-out infinite;
//         }

//         @keyframes spin-slow {
//           0% { transform: rotate(0deg); }
//           100% { transform: rotate(360deg);}
//         }

//         .animate-spin-slow {
//           animation: spin-slow 2s linear infinite;
//         }
//       `}</style>
//     </div>
//   );
// };

// export default LoadingAnimation;
